// extracted by mini-css-extract-plugin
export var root = "oNVK";
export var rootAction = "ssco";
export var rootActionLink = "IuM7";
export var rootContainer = "AEp2";
export var rootText = "eKOK";